<script lang="ts" module>
  /**
   * Interlock's glyph: two S-shaped blocks of four cells each, the second the
   * first turned half a turn and set one cell over and one down, so they lock
   * together along a zigzag with a thin channel between them. Original to
   * Interlock (`docs/decisions/0022` drew the pair for the app icon;
   * `docs/decisions/0057` made it the mark): nothing here is traced or
   * adapted from another logo.
   *
   * The outlines live in `interlock-mark.json`, in cells of a 4 x 3 grid,
   * already inset by 0.12 of a cell on every side (the channel is 0.24 of a
   * cell). `scripts/mark.mjs` rasterises the same outlines for the PWA icons,
   * so the home-screen icon and the frame's mark are one drawing.
   *
   * It is drawn in `currentColor` and sized in `em` (1.2em: the drawing is
   * only three cells tall in its square, so a little over the type step reads
   * as large as the shell's own sample mark), as the shell's
   * `AppFrame` asks of a game's `mark` (`packages/shell/INTEGRATION.md`,
   * `AppFrame`, "The game's name and mark"): the frame's accent tile sets the
   * colour (`--ui-on-accent`) and the size (its type step). Decoration: the
   * frame names the mark after the game where it needs a name.
   */
  import mark from './interlock-mark.json' with { type: 'json' };

  const { width, height } = mark.grid;
  /** A square box round the 4 x 3 drawing, the drawing centred in it. */
  const VIEW_BOX = `0 ${String((height - width) / 2)} ${String(width)} ${String(width)}`;
  const PATHS: readonly string[] = mark.blocks.map(
    (outline) => `M${outline.map(([x, y]) => `${String(x)} ${String(y)}`).join('L')}Z`,
  );
</script>

<svg
  class="mark"
  viewBox={VIEW_BOX}
  width="1.2em"
  height="1.2em"
  fill="currentColor"
  aria-hidden="true"
  focusable="false"
  data-testid="interlock-mark"
>
  {#each PATHS as d (d)}<path {d} />{/each}
</svg>

<style>
  .mark {
    display: block;
  }
</style>
